import React, { useEffect } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { object, string, date } from 'yup';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { sub } from 'date-fns';
import States from '../../../Helpers/Lists/States';
import { InputMaskDate, InputMaskPhone } from '../../../Helpers/Formatters';
import { TextInput, SelectInput } from '../../../Helpers/Inputs';
import GenderButtons from '../../Common/SubComponents/GenderButtons';
import BackNext from '../../Common/SubComponents/BackNext';
import { customValidators } from '../../../Helpers/Validators/customValidators'
import '../../Common/BasicInfo.scss';

export default function BasicInfo(props) {

  const { register, errors, handleSubmit, setValue } = useForm({
    validationSchema: BasicInfo.ValidationSchema(props.ageSpecs),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  // manually call setValue for fields that don't play nice with react-hook-form register
  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
  };

  useEffect(() => {
    // manually register fields for validation that don't play nice with react-hook-form register
    register({ name: 'gender' });
    setValue('gender', props.formState.gender);
    register({ name: 'firstName' });
    setValue('firstName', props.formState.firstName);
    register({ name: 'lastName' });
    setValue('lastName', props.formState.lastName);
    register({ name: 'birthdate' });
    setValue('birthdate', props.formState.birthdate);
    register({ name: 'state' });
    setValue('state', props.formState.state);
    register({ name: 'email' });
    setValue('email', props.formState.email);
    register({ name: 'phone' });
    setValue('phone', props.formState.phone);
  }, [register]);

  return (
    <div className="basic-info d-flex justify-content-center">
      <Form onSubmit={handleSubmit(props.onNext)}>
        <p className="iam mx-auto">{props.juviMode ? "My Child is..." : "I am..."}</p>

        <GenderButtons
          selectedGender={props.formState.gender}
          onClickMale={() => handleValueChange('gender', 'M')}
          onClickFemale={() => handleValueChange('gender', 'F')}
          error={errors.gender} />

        <Row>
          <Col>
            <Form.Group>
              <TextInput
                name="firstName"
                id="first-name"
                label="First Name"
                value={props.formState.firstName}
                errors={errors && errors.firstName}
                inputRef={props.register}
                onChange={(e) => handleValueChange('firstName', e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col>
            <Form.Group>
              <TextInput
                name="lastName"
                id="last-name"
                label="Last Name"
                value={props.formState.lastName}
                errors={errors && errors.lastName}
                inputRef={props.register}
                onChange={(e) => handleValueChange('lastName', e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group>
          <TextInput
            name="birthdate"
            id="birthdate"
            label="Date of Birth"
            value={props.formState.birthdate}
            errors={errors && errors.birthdate}
            inputRef={props.register}
            onChange={(e) => handleValueChange('birthdate', e.target.value)}
            InputProps={{
              inputComponent: InputMaskDate,
            }}
          />
        </Form.Group>

        <Form.Group>
          <SelectInput
            name="state"
            id="state"
            value={props.formState.state}
            onChange={(e) => handleValueChange('state', e.target.value)}
            label="State"
            selectOptions={States()}
            errors={errors && errors.state}
          />
        </Form.Group>

        <Form.Group>
          <TextInput
            name="email"
            id="email"
            label="Email"
            value={props.formState.email}
            errors={errors && errors.email}
            inputRef={props.register}
            onChange={(e) => handleValueChange('email', e.target.value)}
          />
        </Form.Group>

        <Form.Group>
          <TextInput
            name="phone"
            id="phone"
            label="Phone Number"
            value={props.formState.phone}
            errors={errors && errors.phone}
            inputRef={props.register}
            onChange={(e) => handleValueChange('phone', e.target.value)}
            InputProps={{
              inputComponent: InputMaskPhone,
            }}
          />
        </Form.Group>

        <BackNext
          hideBack={props.hideBack}
          onBack={props.onBack}
          continueLabel={{text: "Contact Our Team"}}
        />
      </Form>

    </div>
  );
}

BasicInfo.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  hideBack: PropTypes.bool,
  ageSpecs: PropTypes.object.isRequired
};

BasicInfo.ValidationSchema = (ageSpecs) => {
  return object().shape({
    gender: string().required('Gender is required.'),
    firstName: string().required('First Name is required.').matches(/^[a-zA-Z]+$/, 'Invalid First Name'),
    lastName: string().required('Last Name is required.').matches(/^[a-zA-Z]+$/, 'Invalid Last Name'),
    birthdate: date()
      .typeError('Invalid date.')
      .max(sub(new Date(), { years: ageSpecs.min }), `Minimum age is ${ageSpecs.min}.`)
      .min(sub(new Date(), { years: ageSpecs.max + 1 }), `Maximum age is ${ageSpecs.max}.`)
      .required('Birthdate is required.'),
    state: string().required('State is required.'),
    email: string().email('Invalid Email Address.').required('Email Address is required.'),
    phone: customValidators.string()
      .isValidPhone('Phone Number must be formatted as "(123) 456-7890".')
      .required('Phone Number is required.'),
  })
};

BasicInfo.DefaultFormState = (prefill = false) => {
  return {
    gender: prefill ? 'M' : '',
    firstName: prefill ? 'John' : '',
    lastName: prefill ? 'Doe' : '',
    birthdate: prefill ? '11/15/1970' : '',
    state: prefill ? 'ID' : '',
    email: prefill ? 'user@address.com' : '',
    phone: prefill ? 2081235555 : '',
  };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/LTC/steps/BasicInfo.js